import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { Alert, AlertLevel, AlertStatus } from '../../models/alerts';
import { ALERT_LEVEL_META, ALERT_STATUS_META, AlertLevelMeta, AlertStatusMeta } from '../../models/alert-level.util';

// The mobile equivalent of one row of AlertsComponent's desktop table — a table can't reasonably
// reflow to a narrow viewport, so the Alerts tab (see AlertsComponent's mobile branch) renders a
// stack of these instead. Presentational only: re-emits the same actions AlertsComponent already
// handles for the desktop table (editAlert/duplicateAlert/deleteAlert/toggleActive), so there's
// one place owning that logic regardless of which layout is showing.
@Component({
  selector: 'app-alert-card',
  standalone: true,
  imports: [DatePipe, MatIcon, MatIconButton, MatTooltip],
  templateUrl: './alert-card.component.html',
  styleUrl: './alert-card.component.scss'
})
export class AlertCardComponent {
  @Input({ required: true }) alert!: Alert;

  @Output() edit = new EventEmitter<void>();
  @Output() duplicate = new EventEmitter<void>();
  @Output() delete = new EventEmitter<void>();
  // Re-emits the raw change Event (not just the checked value) — AlertsComponent.toggleActive
  // needs the event's target to revert the switch visually if the API call fails.
  @Output() toggleActive = new EventEmitter<Event>();

  levelMeta(level: AlertLevel): AlertLevelMeta {
    return ALERT_LEVEL_META[level];
  }

  statusMeta(status: AlertStatus): AlertStatusMeta {
    return ALERT_STATUS_META[status];
  }
}
